import { render, staticRenderFns } from "./PqDetailBtn.vue?vue&type=template&id=71b5cbd8&scoped=true&"
import script from "./PqDetailBtn.vue?vue&type=script&lang=js&"
export * from "./PqDetailBtn.vue?vue&type=script&lang=js&"
import style0 from "./PqDetailBtn.vue?vue&type=style&index=0&id=71b5cbd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b5cbd8",
  null
  
)

export default component.exports